// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Compromissos_SaveInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /compromissos/save
 *
 * Validates input for creating or updating a compromisso.
 * compromisso_id = 0 means create, > 0 means update.
 */
import { registerContract } from './validate'

export interface Compromissos_SaveInput {
compromisso_id: number
compromisso_orcamento_id?: number
compromisso_franquia_id?: number
compromisso_operador_user_id?: string
compromisso_titulo?: string
compromisso_total?: string
compromisso_cor_fundo?: string
compromisso_data_hora_inicio?: string
compromisso_data_hora_fim?: string
compromisso_forma_pagamento?: number
compromisso_numero_parcelas?: number
compromisso_tipo?: number
compromisso_checkin?: string
compromisso_checkout?: string
compromisso_entrou_sem_problemas?: number
compromisso_data_cadastro?: string
}

registerContract('Compromissos_SaveInput', {
  compromisso_id:                   { type: 'number',  required: true },
  compromisso_orcamento_id:         { type: 'number',  required: false },
  compromisso_franquia_id:          { type: 'number',  required: false },
  compromisso_operador_user_id:     { type: 'string',  required: false },
  compromisso_titulo:               { type: 'string',  required: false },
  compromisso_total:                { type: 'string',  required: false },
  compromisso_cor_fundo:            { type: 'string',  required: false },
  compromisso_data_hora_inicio:     { type: 'string',  required: false },
  compromisso_data_hora_fim:        { type: 'string',  required: false },
  compromisso_forma_pagamento:      { type: 'number',  required: false },
  compromisso_numero_parcelas:      { type: 'number',  required: false },
  compromisso_tipo:                 { type: 'number',  required: false },
  compromisso_checkin:              { type: 'string',  required: false },
  compromisso_checkout:             { type: 'string',  required: false },
  compromisso_entrou_sem_problemas: { type: 'number',  required: false },
  compromisso_data_cadastro:        { type: 'string',  required: false },
})
